import { createContext } from "react";

export const CommonInfo = createContext({
    profileName: "Nikhil"
})